import posthog from 'posthog-js'

export function identifyUser(uid: string) {
  if (posthog.__loaded) {
    posthog.identify(uid)
  }
}

export function resetUser() {
  if (posthog.__loaded) {
    posthog.reset()
  }
}
